import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { db } from "../../firebase";
import { MyPageDrawer } from "../../components/mypage/index";
import { getUserId } from "../../reducks/users/selectors";

const MyPage = () => {
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const [user, setUser] = useState([]);
  console.log(user);

  const fechUser = () => {
    db.collection("users")
      .doc(uid)
      .get()
      .then((doc) => {
        const data = doc.data();
        setUser(data);
      });
  };

  useEffect(() => {
    fechUser();
    // eslint-disable-next-line
  }, []);

  //elseifで表示するコンポーネントを分ける

  return (
    <div className="mypage-container">
      <MyPageDrawer />
      <div>uid:{uid}</div>
    </div>
  );
};

export default MyPage;
